(function() {
  'use strict';

  if (window.VDAdvancedTabbedSliderLoaded) return;
  window.VDAdvancedTabbedSliderLoaded = true;

  var TIMEZONE = 'Europe/Istanbul';

  function getTimeParts(timeZone, includeSeconds) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: includeSeconds ? '2-digit' : undefined,
      hour12: false
    }).formatToParts(new Date());

    var output = {};
    parts.forEach(function(part) {
      if (part.type === 'year') output.y = part.value;
      if (part.type === 'month') output.m = part.value;
      if (part.type === 'day') output.d = part.value;
      if (part.type === 'hour') output.h = part.value === '24' ? '00' : part.value;
      if (part.type === 'minute') output.min = part.value;
      if (part.type === 'second') output.s = part.value;
    });

    if (!output.s) output.s = '00';
    return output;
  }

  function parseUserTimeToInt(str, currentParts) {
    if (!str || str.trim() === '') return null;

    var p = str.trim().split(/[\s:\-.\/]+/);

    if (p.length === 2) {
      return parseInt(currentParts.y + currentParts.m + currentParts.d + p[0].padStart(2, '0') + p[1].padStart(2, '0'), 10);
    }

    if (p.length >= 5) {
      var y = p[0];
      var m = p[1];
      var d = p[2];

      if (y.length < 4) {
        d = p[0];
        m = p[1];
        y = p[2];
      }

      return parseInt(y.padStart(4, '0') + m.padStart(2, '0') + d.padStart(2, '0') + p[3].padStart(2, '0') + p[4].padStart(2, '0'), 10);
    }

    return null;
  }

  function toSeconds(parts) {
    return new Date(parts.y + '-' + parts.m + '-' + parts.d + 'T' + parts.h + ':' + parts.min + ':' + parts.s).getTime() / 1000;
  }

  function setOverlayRgb(sectionContainer) {
    var overlayHex = sectionContainer.getAttribute('data-overlay-hex');
    if (!overlayHex || overlayHex.length < 7) return;

    var r = parseInt(overlayHex.slice(1, 3), 16);
    var g = parseInt(overlayHex.slice(3, 5), 16);
    var b = parseInt(overlayHex.slice(5, 7), 16);

    if ([r, g, b].some(Number.isNaN)) return;
    sectionContainer.style.setProperty('--ats-overlay-bg-from-rgb', r + ',' + g + ',' + b);
  }

  function getById(id) {
    return id ? document.getElementById(id) : null;
  }

  function pauseVideos(scope, reset) {
    if (!scope) return;

    Array.prototype.forEach.call(scope.querySelectorAll('.ats-media video'), function(video) {
      try {
        video.pause();
        if (reset) video.currentTime = 0;
      } catch (error) {
        // Video may not be ready yet; no action is needed.
      }
    });
  }

  function playActiveVideo(slide, restart) {
    if (!slide || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var videos = Array.prototype.slice.call(slide.querySelectorAll('.ats-media video'));
    var visibleVideo = videos.find(function(video) {
      return window.getComputedStyle(video).display !== 'none';
    });

    videos.forEach(function(video) {
      if (video !== visibleVideo) video.pause();
    });

    if (!visibleVideo) return;

    try {
      visibleVideo.muted = true;
      visibleVideo.playsInline = true;
      if (restart) visibleVideo.currentTime = 0;
      var playPromise = visibleVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    } catch (error) {
      // Autoplay can be blocked by the browser; poster/fallback remains visible.
    }
  }

  function setActiveTab(sectionContainer, button, options) {
    var opts = options || {};
    var targetId = button.getAttribute('data-tab-target');
    var targetPane = getById(targetId);

    if (!targetPane) return;

    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-tab-btn'), function(btn) {
      var isActive = btn === button;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-tab-pane'), function(pane) {
      var isActive = pane === targetPane;
      var slider = pane.querySelector('.ats-slider');

      if (!isActive) {
        if (slider && typeof slider.stopSlider === 'function') slider.stopSlider();
        pauseVideos(pane, false);
      }

      pane.classList.toggle('active', isActive);
      pane.hidden = !isActive;
    });

    var newSlider = targetPane.querySelector('.ats-slider');
    if (newSlider && typeof newSlider.resetSlider === 'function') {
      newSlider.resetSlider();
    }

    if (opts.focus) button.focus({ preventScroll: true });
  }

  function applySchedule(sectionContainer) {
    var now = getTimeParts(TIMEZONE, false);
    var nowInt = parseInt(now.y + now.m + now.d + now.h + now.min, 10);

    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-slide'), function(slide) {
      var start = parseUserTimeToInt(slide.getAttribute('data-start'), now);
      var end = parseUserTimeToInt(slide.getAttribute('data-end'), now);

      if ((start && nowInt < start) || (end && nowInt >= end)) {
        slide.remove();
      }
    });

    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-tab-pane'), function(pane) {
      var paneSlides = Array.prototype.slice.call(pane.querySelectorAll('.ats-slide'));

      if (paneSlides.length === 0) {
        var tabBtn = sectionContainer.querySelector('.ats-tab-btn[data-tab-target="' + pane.id + '"]');
        if (tabBtn) tabBtn.remove();
        pane.remove();
        return;
      }

      paneSlides.forEach(function(slide, index) {
        var isFirst = index === 0;
        slide.classList.toggle('active', isFirst);
        slide.classList.toggle('ats-layout-anchor', isFirst);
        slide.setAttribute('aria-hidden', isFirst ? 'false' : 'true');
      });
    });

    var remainingBtns = Array.prototype.slice.call(sectionContainer.querySelectorAll('.ats-tab-btn'));

    if (remainingBtns.length === 0) {
      sectionContainer.hidden = true;
      return false;
    }

    var activeBtn = sectionContainer.querySelector('.ats-tab-btn.active');
    var activePane = activeBtn ? getById(activeBtn.getAttribute('data-tab-target')) : null;

    if (!activeBtn || !activePane) {
      setActiveTab(sectionContainer, remainingBtns[0]);
    } else {
      setActiveTab(sectionContainer, activeBtn);
    }

    return true;
  }

  function keepTabVisible(navScroll, btn, buttons, currentIndex, previousIndex) {
    if (!navScroll || !btn) return;

    var containerRect = navScroll.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();

    if (btnRect.right > containerRect.right + 2) {
      navScroll.scrollBy({ left: btnRect.right - containerRect.right + 20, behavior: 'smooth' });
      return;
    }

    if (btnRect.left < containerRect.left - 2) {
      navScroll.scrollBy({ left: btnRect.left - containerRect.left - 20, behavior: 'smooth' });
      return;
    }

    var direction = currentIndex - previousIndex;
    var neighbor = direction > 0 ? buttons[currentIndex + 1] : buttons[currentIndex - 1];
    if (!neighbor) return;

    var neighborRect = neighbor.getBoundingClientRect();
    if (direction > 0 && neighborRect.right > containerRect.right + 2) {
      navScroll.scrollBy({ left: neighborRect.right - containerRect.right + 20, behavior: 'smooth' });
    } else if (direction < 0 && neighborRect.left < containerRect.left - 2) {
      navScroll.scrollBy({ left: neighborRect.left - containerRect.left - 20, behavior: 'smooth' });
    }
  }

  function initTabs(sectionContainer) {
    var navScroll = sectionContainer.querySelector('.ats-nav-scroll');
    var buttons = Array.prototype.slice.call(sectionContainer.querySelectorAll('.ats-tab-btn'));
    var lastActiveIndex = buttons.findIndex(function(button) { return button.classList.contains('active'); });
    if (lastActiveIndex < 0) lastActiveIndex = 0;

    buttons.forEach(function(btn, index) {
      var clickHandler = function() {
        var previousIndex = lastActiveIndex;
        setActiveTab(sectionContainer, btn);
        keepTabVisible(navScroll, btn, buttons, index, previousIndex);
        lastActiveIndex = index;
      };

      var keyHandler = function(event) {
        var nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;

        if (nextIndex === null) return;

        event.preventDefault();
        var previousIndex = lastActiveIndex;
        setActiveTab(sectionContainer, buttons[nextIndex], { focus: true });
        keepTabVisible(navScroll, buttons[nextIndex], buttons, nextIndex, previousIndex);
        lastActiveIndex = nextIndex;
      };

      btn.addEventListener('click', clickHandler);
      btn.addEventListener('keydown', keyHandler);
      sectionContainer.atsCleanups.push(function() {
        btn.removeEventListener('click', clickHandler);
        btn.removeEventListener('keydown', keyHandler);
      });
    });
  }

  function updateSlideAria(slides, activeIndex) {
    slides.forEach(function(slide, index) {
      slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
    });
  }

  function initSliders(sectionContainer) {
    var autoplayDelay = parseInt(sectionContainer.getAttribute('data-autoplay'), 10) || 5000;

    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-slider'), function(slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.ats-slide'));
      var controls = slider.querySelector('.ats-custom-controls');
      var prevBtn = slider.querySelector('.ats-control-prev');
      var nextBtn = slider.querySelector('.ats-control-next');
      var currentCountSpan = slider.querySelector('.ats-current-count');
      var totalCountSpan = slider.querySelector('.ats-total-count');

      var currentIndex = 0;
      var timer = null;
      var autoplayStopped = false;
      var touchStartX = 0;
      var touchStartY = 0;

      if (totalCountSpan) totalCountSpan.textContent = slides.length;
      if (currentCountSpan) currentCountSpan.textContent = slides.length ? 1 : 0;

      function stopTimer() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      var slideControlVars = {
        'control-position': '--ats-control-pos',
        'control-top-desktop': '--ats-control-top-desktop',
        'control-right-desktop': '--ats-control-right-desktop',
        'control-top-mobile': '--ats-control-top-mobile',
        'control-right-mobile': '--ats-control-right-mobile',
        'control-bottom-desktop': '--ats-control-bottom-desktop',
        'control-bottom-mobile': '--ats-control-bottom-mobile',
        'control-arrow-desktop': '--ats-control-arrow-size-desktop',
        'control-arrow-mobile': '--ats-control-arrow-size-mobile',
        'control-icon-desktop': '--ats-control-icon-size-desktop',
        'control-icon-mobile': '--ats-control-icon-size-mobile',
        'control-counter-desktop': '--ats-control-counter-size-desktop',
        'control-counter-mobile': '--ats-control-counter-size-mobile',
        'control-gap-desktop': '--ats-control-gap-desktop',
        'control-gap-mobile': '--ats-control-gap-mobile',
        'prev-bg': '--ats-prev-bg',
        'prev-icon': '--ats-prev-icon',
        'prev-border': '--ats-prev-border',
        'next-bg': '--ats-next-bg',
        'next-icon': '--ats-next-icon',
        'next-border': '--ats-next-border',
        'counter-color': '--ats-counter-color'
      };

      var pixelControlKeys = {
        'control-top-desktop': true,
        'control-right-desktop': true,
        'control-top-mobile': true,
        'control-right-mobile': true,
        'control-bottom-desktop': true,
        'control-bottom-mobile': true,
        'control-arrow-desktop': true,
        'control-arrow-mobile': true,
        'control-icon-desktop': true,
        'control-icon-mobile': true,
        'control-counter-desktop': true,
        'control-counter-mobile': true,
        'control-gap-desktop': true,
        'control-gap-mobile': true
      };

      function applySlideControlSettings(slide) {
        Object.keys(slideControlVars).forEach(function(key) {
          slider.style.removeProperty(slideControlVars[key]);
        });

        var globalPlacementDesktop = slider.getAttribute('data-global-controls-placement-desktop') || 'bottom';
        var globalPlacementMobile = slider.getAttribute('data-global-controls-placement-mobile') || 'bottom';

        slider.setAttribute('data-controls-placement-desktop', globalPlacementDesktop);
        slider.setAttribute('data-controls-placement-mobile', globalPlacementMobile);

        if (!slide || slide.getAttribute('data-custom-controls') !== 'true') return;

        var customPlacementDesktop = slide.getAttribute('data-control-placement-desktop') || globalPlacementDesktop;
        var customPlacementMobile = slide.getAttribute('data-control-placement-mobile') || globalPlacementMobile;

        slider.setAttribute('data-controls-placement-desktop', customPlacementDesktop);
        slider.setAttribute('data-controls-placement-mobile', customPlacementMobile);

        Object.keys(slideControlVars).forEach(function(key) {
          var value = slide.getAttribute('data-' + key);
          if (value === null || value === '') return;
          if (pixelControlKeys[key]) value += 'px';
          slider.style.setProperty(slideControlVars[key], value);
        });
      }

      function showSlide(index, options) {
        if (!slides.length) return;

        var opts = options || {};

        slides.forEach(function(slide) {
          slide.classList.remove('active', 'ats-layout-anchor');
          pauseVideos(slide, opts.restartVideo !== false);
        });

        slides[index].classList.add('active', 'ats-layout-anchor');
        currentIndex = index;
        updateSlideAria(slides, currentIndex);
        applySlideControlSettings(slides[currentIndex]);
        playActiveVideo(slides[currentIndex], opts.restartVideo !== false);

        if (currentCountSpan) currentCountSpan.textContent = currentIndex + 1;
      }

      function nextSlide() {
        showSlide((currentIndex + 1) % slides.length);
      }

      function prevSlide() {
        showSlide((currentIndex - 1 + slides.length) % slides.length);
      }

      function startTimer() {
        if (autoplayStopped || slides.length <= 1 || slider.closest('.ats-tab-pane[hidden]')) return;
        stopTimer();
        timer = setInterval(nextSlide, autoplayDelay);
      }

      slider.stopSlider = function() {
        stopTimer();
        pauseVideos(slider, false);
      };

      slider.resetSlider = function() {
        stopTimer();
        autoplayStopped = false;
        showSlide(0, { restartVideo: true });
        startTimer();
      };

      slider.resumeSlider = function() {
        if (slides[currentIndex]) playActiveVideo(slides[currentIndex], false);
        startTimer();
      };

      sectionContainer.atsCleanups.push(function() {
        stopTimer();
        pauseVideos(slider, false);
      });

      if (slides.length <= 1) {
        if (controls) controls.style.display = 'none';
        if (slides.length === 1) showSlide(0);
        return;
      }

      showSlide(0);

      var nextHandler = function(event) {
        event.preventDefault();
        nextSlide();
        stopTimer();
        autoplayStopped = true;
      };

      var prevHandler = function(event) {
        event.preventDefault();
        prevSlide();
        stopTimer();
        autoplayStopped = true;
      };

      var mouseEnterHandler = function() {
        if (!autoplayStopped) stopTimer();
      };

      var mouseLeaveHandler = function() {
        if (!autoplayStopped) startTimer();
      };

      var touchStartHandler = function(event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
        stopTimer();
      };

      var touchEndHandler = function(event) {
        if (!event.changedTouches || !event.changedTouches.length) return;

        var touchEndX = event.changedTouches[0].screenX;
        var touchEndY = event.changedTouches[0].screenY;
        var deltaX = touchEndX - touchStartX;
        var deltaY = touchEndY - touchStartY;
        var swipeThreshold = 48;

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          if (!autoplayStopped) startTimer();
          return;
        }

        if (deltaX < -swipeThreshold) {
          nextSlide();
          stopTimer();
          autoplayStopped = true;
        } else if (deltaX > swipeThreshold) {
          prevSlide();
          stopTimer();
          autoplayStopped = true;
        } else if (!autoplayStopped) {
          startTimer();
        }
      };

      if (nextBtn) nextBtn.addEventListener('click', nextHandler);
      if (prevBtn) prevBtn.addEventListener('click', prevHandler);
      slider.addEventListener('mouseenter', mouseEnterHandler);
      slider.addEventListener('mouseleave', mouseLeaveHandler);
      slider.addEventListener('touchstart', touchStartHandler, { passive: true });
      slider.addEventListener('touchend', touchEndHandler, { passive: true });

      var mediaQuery = window.matchMedia('(max-width: 768px)');
      var mediaChangeHandler = function() {
        if (!slider.closest('.ats-tab-pane.active') || !slides[currentIndex]) return;
        pauseVideos(slider, false);
        playActiveVideo(slides[currentIndex], false);
      };

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', mediaChangeHandler);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(mediaChangeHandler);
      }

      sectionContainer.atsCleanups.push(function() {
        if (nextBtn) nextBtn.removeEventListener('click', nextHandler);
        if (prevBtn) prevBtn.removeEventListener('click', prevHandler);
        slider.removeEventListener('mouseenter', mouseEnterHandler);
        slider.removeEventListener('mouseleave', mouseLeaveHandler);
        slider.removeEventListener('touchstart', touchStartHandler);
        slider.removeEventListener('touchend', touchEndHandler);
        if (typeof mediaQuery.removeEventListener === 'function') {
          mediaQuery.removeEventListener('change', mediaChangeHandler);
        } else if (typeof mediaQuery.removeListener === 'function') {
          mediaQuery.removeListener(mediaChangeHandler);
        }
      });

      startTimer();
    });
  }

  function initCountdowns(sectionContainer) {
    Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-countdown'), function(cd) {
      var dateStr = cd.getAttribute('data-countdown-date');
      var timeStr = cd.getAttribute('data-countdown-time');
      var hideOnEnd = cd.getAttribute('data-countdown-hide') === 'true';
      var boxes = cd.querySelector('.ats-cd-boxes');
      var endTextEl = cd.querySelector('.ats-cd-end-text');
      var daysEl = cd.querySelector('[data-days]');
      var hoursEl = cd.querySelector('[data-hours]');
      var minutesEl = cd.querySelector('[data-minutes]');
      var secondsEl = cd.querySelector('[data-seconds]');

      function getTargetParts() {
        var now = getTimeParts(TIMEZONE, true);
        var target = { y: now.y, m: now.m, d: now.d, h: '23', min: '59', s: '59' };

        if (dateStr && dateStr.trim() !== '') {
          var dateParts = dateStr.trim().split('-');
          if (dateParts.length >= 3) {
            target.y = dateParts[0];
            target.m = dateParts[1];
            target.d = dateParts[2];
          }
        }

        if (timeStr && timeStr.trim() !== '') {
          var timeParts = timeStr.trim().split(':');
          target.h = timeParts[0] || '23';
          target.min = timeParts[1] || '59';
          target.s = timeParts[2] || '00';
        }

        return target;
      }

      function updateCountdown() {
        var now = getTimeParts(TIMEZONE, true);
        var target = getTargetParts();
        var diff = toSeconds(target) - toSeconds(now);

        if (diff <= 0) {
          if (hideOnEnd) {
            cd.hidden = true;
          } else {
            if (boxes) boxes.style.display = 'none';
            if (endTextEl) endTextEl.style.display = 'block';
          }
          return false;
        }

        var days = Math.floor(diff / 86400);
        var hours = Math.floor((diff % 86400) / 3600);
        var minutes = Math.floor((diff % 3600) / 60);
        var seconds = Math.floor(diff % 60);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

        return true;
      }

      if (updateCountdown()) {
        var cdInterval = setInterval(function() {
          if (!updateCountdown()) clearInterval(cdInterval);
        }, 1000);

        sectionContainer.atsCleanups.push(function() {
          clearInterval(cdInterval);
        });
      }
    });
  }

  function cleanupSection(sectionContainer) {
    if (!sectionContainer || !sectionContainer.atsCleanups) return;

    pauseVideos(sectionContainer, false);

    sectionContainer.atsCleanups.forEach(function(cleanup) {
      if (typeof cleanup === 'function') cleanup();
    });

    sectionContainer.atsCleanups = [];
    sectionContainer.dataset.atsInitialized = 'false';
  }

  function initAdvancedTabbedSlider(sectionContainer) {
    if (!sectionContainer || sectionContainer.dataset.atsInitialized === 'true') return;

    sectionContainer.atsCleanups = [];
    sectionContainer.dataset.atsInitialized = 'true';

    setOverlayRgb(sectionContainer);
    if (!applySchedule(sectionContainer)) return;
    initTabs(sectionContainer);
    initSliders(sectionContainer);
    initCountdowns(sectionContainer);
  }

  function initAllAdvancedTabbedSliders(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.ats-section'), initAdvancedTabbedSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllAdvancedTabbedSliders(document);
    });
  } else {
    initAllAdvancedTabbedSliders(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target) initAllAdvancedTabbedSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (!event.target) return;
    Array.prototype.forEach.call(event.target.querySelectorAll('.ats-section'), cleanupSection);
  });

  document.addEventListener('visibilitychange', function() {
    Array.prototype.forEach.call(document.querySelectorAll('.ats-section'), function(sectionContainer) {
      Array.prototype.forEach.call(sectionContainer.querySelectorAll('.ats-slider'), function(slider) {
        if (document.hidden && typeof slider.stopSlider === 'function') {
          slider.stopSlider();
        } else if (!document.hidden && slider.closest('.ats-tab-pane.active') && typeof slider.resumeSlider === 'function') {
          slider.resumeSlider();
        }
      });
    });
  });
})();
